export default __webpack_public_path__ + "static/leader-55aa8e77d44dfcd3c4652c354625f400.webp";